function recoveryFromHistory(historyRecord){
    let historyObject = {
        minigameData: historyRecord.minigame.form,
        playerAns: historyRecord.playerAns,
        isCompleted: historyRecord.completed,
        score: historyRecord.score,
        maxScore: historyRecord.maxScore,
        title: historyRecord.minigame.title,
        name: historyRecord.minigame.name
    }
    switch(historyObject.minigameData.type){
        case "Question":
        case "ManyAnsQuestion":    
            return recoveryQuestion(historyObject);
        default:
            return undefined;
    }
}

function recoveryQuestion({minigameData, playerAns, name, title, isCompleted, score, maxScore}){
    return {
        title,
        name,
        form: minigameData,
        playerAns,
        isCompleted,
        score,
        maxScore
    }
}

export default recoveryFromHistory;